import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const NuestrosClientes = () => {
    return (
        <section className="section bg-primary vertical nuestros-clientes" id="ourclients">
            <Container fluid>
                <Row>
                    <Col lg={12} className="mt-5">
                        <h1 className="heading1 text-white">Nuestros Clientes</h1>
                    </Col>
                </Row>
                <Row>
                    <Col lg={3} className="p-0">
                        <div className="cliente_image px-4 py-2" id="cliente_empresas">
                            <h3>Empresas de mediana y gran escala</h3>
                            <p>Buscan asesoría estratégica para expandirse a nuevos mercados o mejorar su competitividad.</p>
                        </div>
                    </Col>
                    <Col lg={3} className="p-0">
                        <div className="cliente_image_2 px-4 py-2" id="cliente_gobierno">
                            <h3>Organizaciones Gubernamentales</h3>
                            <p>Necesitan apoyo en planificación estratégica y análisis de políticas en entornos cambiantes.</p>
                        </div>
                    </Col>
                    <Col lg={3} className="p-0">
                        <div className="cliente_image px-4 py-2" id="cliente_ong">
                            <h3>ONG's</h3>
                            <p>Buscan estrategias efectivas para maximizar su impacto en la comunidad y asegurar financiamiento.</p>
                        </div>
                    </Col>
                    <Col lg={3} className="p-0">
                        <div className="cliente_image_2 p-3" id="cliente_industria">
                            <h3>Industrias tradicionales</h3>
                            <p>Que buscan modernizar sus procesos y adaptarse a la digitalización y la globalización.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default NuestrosClientes;